import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import RevokePSUAccessComponent from '../../components/RevokePSUAccessComponent/RevokePSUAccessComponent'

const RevokePSUAccess = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <RevokePSUAccessComponent/>
                </div>
            </div>
        </div>
    )
}

export default RevokePSUAccess
